/* global COMPANY_ID */
/**
 * defines a structural wrapper for sidenav layout
 * requiresAuth added, so this is inheriuted by all child states
 * @type {{name: string, url: string, abstract: boolean, data: {requiresAuth: boolean}, views: {main@: string}}}
 */
export const customersParentState = {
  name: 'customers',
  url: '/customers',
  abstract: true,
  data: {
    requiresAuth: true,
  },
  views: {
    'main@': 'customerParentComponent',
  },
}

export const customersState = {
  name: 'customers.customer',
  url: '/:customerId',
  abstract: true,
  views: {
    'sidenav@customers': 'umsSideNav',
  },
  resolve: {
    customer: (CustomerService, $stateParams) => {
      'ngInject'
      return CustomerService.load($stateParams.customerId, COMPANY_ID)
    },
    tasksites: (customer) => {
      'ngInject'
      return customer.getTasksites()
    },
  },
}



// WEBPACK FOOTER //
// ./app/customers/customers.states.js